import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IBarChartSignLegendProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import BarChartSignKey from "../signKey";
import Text from "../../../text";

const BarChartSignLegend: FC<IBarChartSignLegendProps> = ({
    customLocalize,
    customTheme,
    style,
    ...props
}) => {
    const {
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        container: containerDynamicStyle,
        item: itemDynamicStyle
    } = useStyles({
        spaces
    });

    const items = [
        {
            color: colors.chart.diverging.positive,
            title: localize("chart-positive")
        },
        {
            color: colors.chart.diverging.negative,
            title: localize("chart-negative")
        }
    ];

    return <View
        {...props}
        accessibilityLabel={props.accessibilityLabel ?? localize("chart-series")}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="group"
    >
        {
            items.map((item) => <View
                style={[
                    stylesheet.item,
                    itemDynamicStyle
                ]}
                key={item.title}
            >
                <BarChartSignKey
                    customTheme={customTheme}
                    color={item.color}
                />
                <Text
                    customTheme={customTheme}
                    variant="bodySmallSize"
                    numberOfLines={1}
                    color="mid"
                >
                    {item.title}
                </Text>
            </View>)
        }
    </View>;
};
export default BarChartSignLegend;
